import { JSX } from 'react'

import { IconProps } from '../../icon'

const Note: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M39.9197 30.2346L35.6687 13.8706C35.2748 12.3441 33.6991 11.425 32.1727 11.8189L17.4499 15.6432C16.7113 15.8402 16.0876 16.2997 15.6937 16.9727C15.2998 17.6292 15.2013 18.4006 15.3983 19.1557L18.1885 29.9228L10.819 28.0024C10.6548 27.9696 10.5728 27.8547 10.54 27.789C10.5071 27.7234 10.4579 27.6085 10.4907 27.4444L14.2822 12.8037C14.3478 12.5575 14.594 12.4098 14.8402 12.4754L18.5168 13.4274C19.1733 13.5915 19.8463 13.1976 20.0104 12.5411C20.1746 11.8846 19.7806 11.2116 19.1241 11.0475L15.4475 10.0955C13.8719 9.68518 12.2962 10.6372 11.9023 12.18L8.09437 26.8371C7.89741 27.5921 8.01231 28.3799 8.40622 29.0529C8.80014 29.7258 9.44026 30.2018 10.1789 30.3988L18.8779 32.6638L19.6165 35.5197C19.8135 36.2583 20.273 36.882 20.946 37.2759C21.3891 37.5385 21.8979 37.6698 22.3903 37.6698C22.6365 37.6698 22.8827 37.637 23.1125 37.5714L37.8517 33.7471C39.3781 33.3531 40.3137 31.7775 39.9033 30.251L39.9197 30.2346ZM37.2444 31.3507L22.5052 35.175C22.3575 35.2078 22.2426 35.175 22.1934 35.1258C22.1441 35.093 22.0457 35.0109 21.9964 34.8796L17.7454 18.5155C17.7126 18.3678 17.7454 18.2529 17.7946 18.2037C17.8275 18.138 17.9095 18.056 18.0408 18.0231L32.7635 14.1988C32.7635 14.1988 32.8292 14.1988 32.862 14.1988C33.0426 14.1988 33.2067 14.3301 33.2559 14.5107L37.507 30.8747C37.5562 31.0881 37.4249 31.3179 37.2115 31.3671L37.2444 31.3507Z'
      fill='black'
    />
    <path
      d='M30.6791 19.6809L22.5381 21.7982C21.8816 21.9623 21.4876 22.6353 21.6518 23.2918C21.7995 23.8498 22.2919 24.2109 22.8335 24.2109C22.932 24.2109 23.0469 24.2109 23.1454 24.1781L31.2864 22.0608C31.9429 21.8967 32.3368 21.2237 32.1727 20.5672C32.0086 19.9107 31.3356 19.5167 30.6791 19.6809Z'
      fill='black'
    />
    <path
      d='M28.611 26.5252L24.0809 27.707C23.4244 27.8711 23.0305 28.544 23.1946 29.2006C23.3423 29.7586 23.8347 30.1197 24.3764 30.1197C24.4749 30.1197 24.5897 30.1197 24.6882 30.0869L29.2183 28.9051C29.8748 28.741 30.2687 28.0681 30.1046 27.4115C29.9405 26.755 29.2675 26.3611 28.611 26.5252Z'
      fill='black'
    />
  </svg>
)

export default Note
